import {
  createLength,
  lengthToFeet,
  lengthToInches,
  lengthToMetres,
  lengthToCentimetres,
} from 'measure-fns';

export const convertLength = (
  rawLength: number,
  unit: string | undefined,
  largeUnits = false,
  dynamic = false,
): string => {
  const resolvedUnit = unit ?? 'ft';
  const length = createLength(rawLength);
  switch (resolvedUnit) {
    case 'ft':
      if (dynamic) {
        const ft = lengthToFeet(createLength(rawLength), { round: true });
        // eslint-disable-next-line no-magic-numbers
        const inches = lengthToInches(createLength(rawLength), { round: true }) - ft * 12;
        return `${ft > 0 ? `${ft} ft` : ''} ${inches > 0 ? `${inches} in` : ''}`;
      }
      return largeUnits
        ? `${lengthToFeet(length, { round: true })} ft`
        : `${lengthToInches(length, { round: true })} in`;
    case 'm':
      return largeUnits
        ? `${lengthToMetres(length, { round: true })} m`
        : `${lengthToCentimetres(length, { round: true })} cm`;
    default:
      throw new Error(`Unsupported unit: ${resolvedUnit}`);
  }
};
